module.exports = {
  __depends__: [ require(131) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(122) ],
  elementRegistry: [ 'type', require(124) ],
  elementFactory: [ 'type', require(123) ],
  eventBus: [ 'type', require(125) ],
  graphicsFactory: [ 'type', require(126) ]
};